<!-- ── Display mode ─────────────────────────────────────────────── -->
@if (!editMode) {
  <div class="pv-wrapper">
    <div class="pv-display">
      <span class="pv-label">מספר טלפון</span>
      <span class="pv-value" dir="ltr">{{ phone || '—' }}</span>
      <button type="button" class="pv-btn-edit" (click)="startEdit()">
        <i class="mdi mdi-pencil"></i>
        שנה מספר
      </button>
    </div>
  </div>
}

<!-- ── Edit mode ────────────────────────────────────────────────── -->
@if (editMode) {
  <div class="pv-wrapper">
    <div class="pv-edit-row">
      <input
        class="pv-input"
        [(ngModel)]="newPhone"
        name="newPhone"
        type="tel"
        placeholder="0501234567"
        maxlength="10"
        dir="ltr"
        [class.pv-input--error]="phoneError"
        (input)="onPhoneInput()"
        />
      <button
        type="button"
        class="pv-btn-send"
        [disabled]="sending || !!phoneError || !newPhone"
        (click)="requestOtp()"
        >
        @if (sending) {
          <i class="mdi mdi-loading mdi-spin"></i>
        }
        @if (!sending) {
          <i class="mdi mdi-message-text-outline"></i>
        }
        {{ sending ? 'שולח...' : 'שלח קוד' }}
      </button>
      <button type="button" class="pv-btn-cancel" (click)="cancelEdit()" title="ביטול">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
    <div class="pv-hint">מספר נייד ישראלי בלבד — 10 ספרות המתחילות ב-05</div>
    @if (phoneError) {
      <div class="pv-error">
        <i class="mdi mdi-alert-circle-outline"></i> {{ phoneError }}
      </div>
    }
  </div>
}

<!-- ── OTP Modal ─────────────────────────────────────────────────── -->
@if (showOtpModal) {
  <div class="otp-overlay" (click)="closeModal()">
    <div class="otp-modal" (click)="$event.stopPropagation()">
      <!-- close -->
      <button aria-label="סגירה" class="otp-modal__close" (click)="closeModal()">
        <i class="mdi mdi-close"></i>
      </button>
      <!-- icon -->
      <div class="otp-modal__icon">
        <i class="mdi mdi-cellphone"></i>
      </div>
      <h3 class="otp-modal__title">אימות מספר טלפון</h3>
      <p class="otp-modal__sub">
        נשלח קוד אימות למספר
        <strong dir="ltr">{{ newPhone }}</strong>
      </p>
      <!-- code input -->
      <div class="otp-modal__input-wrap">
        <input
          class="otp-modal__input"
          [(ngModel)]="otpCode"
          name="otpCode"
          type="tel"
          maxlength="6"
          placeholder="• • • • • •"
          dir="ltr"
          (keyup.enter)="verifyOtp()"
          />
      </div>
      @if (otpError) {
        <div class="otp-modal__error">
          <i class="mdi mdi-alert-circle-outline"></i> {{ otpError }}
        </div>
      }
      <!-- verify button -->
      <button
        class="otp-modal__btn-verify"
        [disabled]="verifying || otpCode.length < 4"
        (click)="verifyOtp()"
        >
        @if (verifying) {
          <i class="mdi mdi-loading mdi-spin"></i>
        }
        @if (!verifying) {
          <i class="mdi mdi-check-circle-outline"></i>
        }
        {{ verifying ? 'מאמת...' : 'אמת מספר' }}
      </button>
      <!-- resend -->
      <button class="otp-modal__btn-resend" [disabled]="sending" (click)="resendOtp()">
        <i class="mdi mdi-refresh"></i>
        {{ sending ? 'שולח...' : 'שלח קוד מחדש' }}
      </button>
    </div>
  </div>
}
